export enum Language {
	EN = 'en',
	ES = 'es',
	FR = 'fr'
}


// WEBPACK FOOTER //
// ./src/ts/Apps/common/interfaces/Language.ts